import type { StateFinding } from '@/lib/apiTypes'
import { viewOf, findingAttribute, readVerification } from '@/features/state/lib/findingView'
import { Tooltip } from '@/shared/components/Tooltip'
import { DetailCell } from '@/features/state/components/DetailCell'
import { VerificationBadge } from '@/features/state/components/VerificationBadge'

/** One occurrence line inside an expanded row: where it was, which attribute, and the extras its
 *  category carries. */
export function OccurrenceLine({ f }: { f: StateFinding }) {
  const view = viewOf(f)
  const attr = findingAttribute(f)
  const verification = readVerification(f.meta)
  const loc = view.where ?? '(unresolved)'
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'baseline', flexWrap: 'wrap' }}>
      <Tooltip
        interactive
        placement="top"
        text={
          <div style={{ display: 'grid', gap: 4, fontFamily: 'var(--mono)', fontSize: '0.7rem' }}>
            <div><span className="dim">resource </span>{view.where ?? '(unresolved)'}</div>
            {attr && <div><span className="dim">attribute </span>{attr}</div>}
            {view.whereType && <div><span className="dim">type </span>{view.whereType}</div>}
          </div>
        }
      >
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          style={{ background: 'none', border: 'none', fontFamily: 'var(--mono)', fontSize: '0.72rem', color: 'var(--text2)', cursor: 'help', textAlign: 'left', padding: 0 }}
        >
          {loc}
        </button>
      </Tooltip>
      {/* The attribute is NOT repeated here when it is already the Detail cell's content - the
          old secrets table printed it twice, in the tooltip and inline. */}
      {view.detail.kind !== 'text' && <DetailCell detail={view.detail} />}
      {verification && <VerificationBadge state={verification} />}
    </div>
  )
}

